<section *ngIf="prop; else loadingData" [class]="smallCard ? 'property-card small-card' : 'property-card'">
  <a [routerLink]="routerLink" class="link" appTooltip="Voir les détails du bien">

    <!-- left -->
    <div id="img">
      <img *ngIf="mainPhoto" [src]="mainPhoto" />
    </div>

    <!-- right -->
    <div class="right">
      <div id="icons">
        <app-certification-badge [prop]="prop" [size]="certifBadgeSize"
          [class.separator]="prop.certified"></app-certification-badge>
        <ul class="row-list">
          <li *ngIf="propertyHelper.isInCondo(prop)">
            <mat-icon color="accent" appTooltip="Fait partie d'une copropriété"
              aria-label="Fait partie d'une copropriété" class="small-icon">{{ condoImageName }}</mat-icon>
          </li>
          <li *ngIf="!userHelper.isPropertyOwner(prop) && userHelper.canUpdateProperty(prop)">
            <mat-icon color="accent" appTooltip="Droits d'accès en délégation sur le bien"
              aria-label="Droits d'accès en délégation sur le bien" class="small-icon">vpn_key</mat-icon>
          </li>
          <li>
            <mat-icon color="accent" class="small-icon" [appTooltip]="'enum.PropertyType.' + prop.type | translate">{{
              badgeImageName }}</mat-icon>
          </li>
        </ul>
      </div>
      <div *ngIf="prop.demo" class="banner demo">
        <span>DEMO</span>
      </div>
      <div *ngIf="isOnSelling" class="banner selling">
        <span>{{ 'enum.SellingStatus.'+sellingStatus | translate }}</span>
      </div>
      <header id="content">
        <h1>
          <ng-template *ngIf="showOwnerName; then ownerNameField; else propNameField"></ng-template>
          <ng-template #ownerNameField>{{ ownerName }}</ng-template>
          <ng-template #propNameField>{{ propName }}</ng-template>
        </h1>
        <p class="subtitle">{{'enum.PropertyType.' + prop.type | translate}}</p>
        <p *ngIf="isOnSelling" class="price">{{price | currency: 'EUR':'symbol':'1.0' }}</p>
      </header>
      <div id="footer" *ngIf="showAddress && prop.address">
        <mat-icon class="place">location_on</mat-icon>
        <address *ngIf="prop.address">
          <p *ngFor="let item of displayAddress">{{item}}</p>
        </address>
      </div>

    </div>
  </a>

  <div *ngIf="showFavorite" class="favorite">
    <a [appTooltip]="isFavorite ? 'Supprimer des favoris' : 'Ajouter au favoris'" (click)="toogleFavorite()">
      <mat-icon color="primary">{{ isFavorite ? 'favorite' : 'favorite_border'}}</mat-icon>
    </a>
  </div>
</section>
<!--<section *ngIf="showMapLink && prop.location" class="mapLink">
  <span class="w-100 text-center">Gps: {{ prop.location?.latitude }}, {{ prop.location?.longitude }}</span>
  <span class="spacer"></span>
  <a [href]="externalMapLink" appTooltip="Voir sur Maps" target="_blank">
    <mat-icon color="primary">map</mat-icon>
  </a>
</section>-->

<ng-template #loadingData>
  <div class="p-5 d-flex justify-content-center">
    <mat-icon>
      <mat-spinner diameter="20">
      </mat-spinner>
    </mat-icon>
  </div>
</ng-template>